// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"m1-z","colorTextValue":"n1-z","swatches":"o1-z","collapseLink":"p1-z","isCollapsed":"q1-z","dropdown":"r1-z","disabled":"s1-z"};